import Cookies from 'js-cookie';

export const SIZE100MB = 1024 * 1024 * 100;
export const ACTION = '/v4/supertext-py/api/file/upload/';
export const MAX_TASK_COUNT = 10;
export const geneHeaders = () => ({
  Authorization: Cookies.get(TOKEN_NAME) || '',
});

export const FILE_TYPES = ['.doc', '.docx', '.wps', '.pdf', '.ofd', '.txt'];
export const IMAGE_TYPES = ['.jpg', '.jpeg', '.png', '.tiff', '.tif'];
export const EXCEL_TYPES = ['.xls', '.xlsx', '.et'];

export const DEFAULT_ACCEPT = [...FILE_TYPES, ...IMAGE_TYPES].join(',');
export const FINANCIAL_ANALYSIS_ACCEPT = [
  ...FILE_TYPES,
  ...IMAGE_TYPES,
  ...EXCEL_TYPES,
].join(',');
export const OCR_ACCEPT = ['.jpg', '.jpeg', '.png'].join(',');
